/// <amd-module name="TFS/Token/PatTokenPage/Constants/TokenConstants" />
export const AppToken = "app_token";
export const AllOrganizations = "allOrgs";
export const CurrentOrganization = "currentOrg";
export const ScopeSelectionFull = "full";
export const ScopeSelectionCustom = "custom";

// Telemetry
export const PersonalAccessTokenPage = "PersonalAccessTokenPage";

export enum PatPageTelemetry {
    PatPageView = "PatPageView",
    PatPageAddToken = "PatAddToken",
    PatPageRevokeToken = "PatRevokeToken",
    PatPageUpdateToken = "PatUpdateToken",
    PatPageLoadedMoreTokensOnClick = "PatPageLoadedMoreTokensOnClick",
    PatPagePanelOpened = "PatPagePanelOpened",
    PatPageResetTokens = "PatPageResetTokens"
}

export enum PatPageKeys {
    authorizationId = "authorizationId",
    userId = "userId",
    scope = "scope",
    fetchVersion = "fetchVersion",
    currentRow = "currentRow",
    panelType = "panelType",
    filterType = "filterType",
    sortBy = "sortBy",
    nextRowNumber = "nextRowNumber",
    tokenValidTo = "tokenValidTo",
    isTokenValid = "isTokenValid"
}

export const enum ServiceInstanceTypes {
    SPS = "951917ac-a960-4999-8464-e3f0aa25b381"
}
